module.exports = __webpack_public_path__ + "static/media/NHIS_logo.71bd417f.png";